module.exports = __webpack_public_path__ + "media/images/landing/working-from-anywhere-6593ee75497a0d5c2698f20d2eac2166.svg";